// NAVBAR SCRIPT START
(function() {
    const nav = document.querySelector(".nav");
    const fixedContact = document.querySelector(".pd-fixed-contact-main");
    
    if (!nav) return;

    let lastScrollY = window.scrollY;
    let isScrolling = false;
    
    // Initial state set karo
    if (window.scrollY <= 10) {
        nav.classList.remove("nav-hidden");
        nav.classList.remove("white-navbar");
    }

    // Main scroll handler - ye sab se important hai
    function handleScroll() {
        if (isScrolling) return;
        
        isScrolling = true;
        requestAnimationFrame(() => {
            const currentY = window.scrollY;
            
            // Agar top par hai toh reset karo
            if (currentY <= 10) {
                nav.classList.remove("nav-hidden");
                nav.classList.remove("white-navbar");
                lastScrollY = currentY;
                isScrolling = false;
                return;
            }
            
            // Scroll direction check karo
            if (currentY > lastScrollY) {
                // Neeche scroll - navbar hide
                nav.classList.add("nav-hidden");
                nav.classList.remove("white-navbar");
            } else {
                // Upar scroll - navbar show with white background
                nav.classList.remove("nav-hidden");
                if (currentY > 50) {
                    nav.classList.add("white-navbar");
                } else {
                    nav.classList.remove("white-navbar");
                }
            }
            
            lastScrollY = currentY;
            isScrolling = false;
        });
    }

    // Scroll listener add karo
    window.addEventListener("scroll", handleScroll, { passive: true });

    // Extra: visibility change par reset
    document.addEventListener('visibilitychange', function() {
        if (!document.hidden && window.scrollY <= 10) {
            nav.classList.remove('nav-hidden');
            nav.classList.remove('white-navbar');
        }
    });

    // Extra: page show par reset
    window.addEventListener('pageshow', function() {
        if (window.scrollY <= 10) {
            nav.classList.remove('nav-hidden');
            nav.classList.remove('white-navbar');
        }
    });

    // ─── PD NAVBAR CONTACT (agar hai toh) ──────────────────
    if (nav.classList.contains("pd-navbar") && fixedContact) {
        const NAV_HEIGHT = nav.getBoundingClientRect().height;
        const CONTACT_HEIGHT = fixedContact.getBoundingClientRect().height;
        let contactTicking = false;

        function updateContactTop() {
            if (contactTicking) return;
            contactTicking = true;
            requestAnimationFrame(() => {
                const isNavHidden = nav.classList.contains("nav-hidden");
                if (window.scrollY <= 400) {
                    fixedContact.style.top = `-${CONTACT_HEIGHT}px`;
                } else {
                    fixedContact.style.top = isNavHidden ? "0px" : NAV_HEIGHT + "px";
                }
                contactTicking = false;
            });
        }

        window.addEventListener("scroll", updateContactTop, { passive: true });
        setTimeout(updateContactTop, 100);
    }

    // ─── MEGA MENU (existing code ko yahan se continue karo) ──
    // Apna existing mega menu code yahan rakh do...
    // ...

})();
// NAVBAR SCRIPT END
document.addEventListener("DOMContentLoaded", function () {

  const header = document.querySelector(".nav");
  let megaMenuOpen = false;

  // ─── MEGA MENU HEIGHT ─────────────────────────────────────────────────────
  function setMegaMenuHeights() {
    const navHeight = header.getBoundingClientRect().height;
    document.querySelectorAll(".mega-menu-desk").forEach(function (menu) {
      const isOpen = menu.closest("li").classList.contains("mega-menu-active");
      menu.style.height = isOpen ? `calc(100vh - ${navHeight}px)` : "0";
    });
  }

  setMegaMenuHeights();
  window.addEventListener("resize", setMegaMenuHeights);

  // ─── MEGA MENU OPEN / CLOSE ───────────────────────────────────────────────
  const togglers = document.querySelectorAll(".mega-menu-toggler");

  togglers.forEach(function (toggler) {
    const parentLi = toggler.closest("li");
    const megaMenu = parentLi.querySelector(".mega-menu-desk");

    if (!megaMenu) return;

    toggler.addEventListener("click", function (e) {
      e.stopPropagation();

      const isActive = parentLi.classList.contains("mega-menu-active");

      document.querySelectorAll("li.mega-menu-active").forEach(function (el) {
        el.classList.remove("mega-menu-active");
      });
      document.body.style.overflow = "";

      if (!isActive) {
        parentLi.classList.add("mega-menu-active");
        document.body.style.overflow = "hidden";
        if (header) header.classList.add("white-navbar");
        megaMenuOpen = true;
        initMegaMenuTabs(megaMenu);
        setMegaMenuHeights();
      } else {
        if (header) header.classList.remove("white-navbar");
        megaMenuOpen = false;
        setMegaMenuHeights();
      }
    });
  });

  document.querySelectorAll(".mega-menu-desk").forEach(function (menu) {
    menu.addEventListener("click", function (e) {
      e.stopPropagation();
    });
  });

  document.querySelectorAll(".close-mega-menu").forEach(function (btn) {
    btn.addEventListener("click", function () {
      document.querySelectorAll("li.mega-menu-active").forEach(function (el) {
        el.classList.remove("mega-menu-active");
      });
      document.body.style.overflow = "";
      if (header) header.classList.remove("white-navbar");
      megaMenuOpen = false;
      setMegaMenuHeights();
    });
  });

  // ─── TAB LOGIC ────────────────────────────────────────────────────────────
  function initMegaMenuTabs(megaMenu) {
    const tabs = megaMenu.querySelectorAll(
      ".mega-menu-left .mega-menu-desk-inner-menu-toggle"
    );

    const panels = megaMenu.querySelectorAll(
      ".mega-menu-right-main .mega-menu-right"
    );

    function activate(collectionEl) {
      const collection = collectionEl.getAttribute("data-collection");

      // reset
      tabs.forEach(t => t.classList.remove("tab-active"));
      panels.forEach(p => p.classList.remove("panel-active"));

      // activate tab
      collectionEl.classList.add("tab-active");

      // activate matching panel
      const activePanel = megaMenu.querySelector(
        `.mega-menu-right[data-collection="${collection}"]`
      );

      if (activePanel) {
        activePanel.classList.add("panel-active");
      }
    }

    // click events
    tabs.forEach(tab => {
      tab.addEventListener("click", function () {
        activate(tab);
      });
    });

    // ✅ AUTO SELECT FIRST VALID TAB (IMPORTANT FIX)
    let firstValidTab = null;

    for (let i = 0; i < tabs.length; i++) {
      const collection = tabs[i].getAttribute("data-collection");
      const panel = megaMenu.querySelector(
        `.mega-menu-right[data-collection="${collection}"]`
      );

      if (panel) {
        firstValidTab = tabs[i];
        break;
      }
    }

    // fallback: first tab if nothing found
    if (!firstValidTab && tabs.length) {
      firstValidTab = tabs[0];
    }

    if (firstValidTab) {
      activate(firstValidTab);
    }
  }

  function activatePanel(tabs, panels, activeIndex) {
    tabs.forEach(function (tab, i) {
      tab.classList.toggle("tab-active", i === activeIndex);
    });

    panels.forEach(function (panel, i) {
      panel.classList.toggle("panel-active", i === activeIndex);
    });
  }

});

      // RESPONSIVE MEGA MENU
      // ====================== MAIN POPUP ======================


      const navPopupTogglers = document.querySelectorAll('.nav-popup-toggler');
      const popupMain = document.querySelector('.nav-popup-main');
      const popupInner = document.querySelector('.nav-popup-inner');
function toggleNavPopup() {
    popupMain.classList.toggle('nav-popup-active');
    const ham = document.querySelector('.ham-icon');
    ham.classList.toggle('ham-active');
    console.log(ham.classList);

    const nav = document.querySelector('nav'); // ← grab the nav element

    if (popupMain.classList.contains('nav-popup-active')) {
        document.body.style.overflow = 'hidden';
        nav.classList.add('white-navbar'); // ← add when popup opens
    } else {
        document.body.style.overflow = '';
        nav.classList.remove('white-navbar'); // ← remove when popup closes
        closeAllMegaMenus();
    }
}
document.querySelector('.ham-icon').addEventListener('click', toggleNavPopup);

navPopupTogglers.forEach(toggler => {
    toggler.addEventListener('click', function(e) {
        const isAnchor = this.tagName.toLowerCase() === 'a';
        if (!isAnchor) e.preventDefault();
        toggleNavPopup();
    });
});

popupMain.addEventListener('click', function(e) {
    if (e.target === popupMain) toggleNavPopup();
});


// ====================== MEGA MENU LOGIC (LEVEL 2) ======================
const megaMenuTogglers = document.querySelectorAll('.mega-menu-toggler');
const megaMenus = document.querySelectorAll('.nav-popup-mega-menu');

function closeAllInnerInnerMenus() {
    document.querySelectorAll('.nav-popup-mega-menu-inner-inner').forEach(menu => {
        menu.classList.remove('inner-inner-menu-active');
    });
}

function closeAllMegaMenus() {
    megaMenus.forEach(menu => {
        menu.classList.remove('nav-popup-mega-menu-active');
    });
    closeAllInnerInnerMenus();
    unlockPanel(popupInner);
}
function lockPanel(panel) {
    if (!panel) return;
    panel.style.overflow = 'hidden';
    panel.scrollTop = 0;
}

function unlockPanel(panel) {
    if (!panel) return;
    panel.style.overflow = 'auto';
}


megaMenuTogglers.forEach(toggler => {
    toggler.addEventListener('click', function(e) {
        const isAnchor = this.tagName.toLowerCase() === 'a';
        if (!isAnchor) e.preventDefault();

        const parentLi = this.closest('li');

        // Level 3 — toggler is inside an active mega menu
        const parentInnerMenu = this.closest('.nav-popup-mega-menu');
        if (parentInnerMenu) {
            e.stopPropagation();

            const innerInnerMenu = parentLi
                ? parentLi.querySelector('.nav-popup-mega-menu-inner-inner')
                : null;

            if (!innerInnerMenu) return;

            if (innerInnerMenu.classList.contains('inner-inner-menu-active')) {
              innerInnerMenu.classList.remove('inner-inner-menu-active');
              unlockPanel(parentInnerMenu);   // restore mega menu scroll
            } else {
                parentInnerMenu.querySelectorAll('.nav-popup-mega-menu-inner-inner').forEach(m => {
                    m.classList.remove('inner-inner-menu-active');
                });
                lockPanel(parentInnerMenu);   // lock the mega menu panel before opening child
                innerInnerMenu.classList.add('inner-inner-menu-active');
}


            return; // stop here, don't run level 2 logic
        }

        // Level 2 — toggler is in the main nav
        const megaMenu = parentLi ? parentLi.querySelector('.nav-popup-mega-menu') : null;
        if (!megaMenu) return;

        if (megaMenu.classList.contains('nav-popup-mega-menu-active')) {
            megaMenu.classList.remove('nav-popup-mega-menu-active');
            closeAllInnerInnerMenus();
            unlockPanel(popupInner);
        } else {
          closeAllMegaMenus();
          lockPanel(popupInner);   // locks + scrolls to top in one call
          megaMenu.classList.add('nav-popup-mega-menu-active');
        }
    });
});


// ====================== INNER INNER MENU LOGIC (LEVEL 3) ======================

megaMenuTogglers.forEach(toggler => {

    toggler.addEventListener('click', function(e) {

        const isAnchor = this.tagName.toLowerCase() === 'a';

        if (!isAnchor) e.preventDefault();

        const collectionHandle = this.dataset.collection;

        // find matching products panel
        const targetMenu = document.querySelector(
            `.nav-popup-mega-menu-inner-inner[data-collection-products="${collectionHandle}"]`
        );

        if (!targetMenu) return;

        // close all open product panels
        document.querySelectorAll('.nav-popup-mega-menu-inner-inner').forEach(menu => {
            menu.classList.remove('inner-inner-menu-active');
        });

        // open clicked collection panel
        targetMenu.classList.add('inner-inner-menu-active');

    });

});


// ====================== BACK BUTTONS ======================
// Works for ALL levels — finds the nearest panel and closes it
document.querySelectorAll('.back-btn').forEach(backBtn => {
    backBtn.addEventListener('click', function() {

        // Level 3 — inside an inner-inner menu
        const innerInnerMenu = this.closest('.nav-popup-mega-menu-inner-inner');
        if (innerInnerMenu) {
            const parentMegaMenu = innerInnerMenu.closest('.nav-popup-mega-menu');
            innerInnerMenu.classList.remove('inner-inner-menu-active');
            unlockPanel(parentMegaMenu);   // restore mega menu scroll on back
            return;
        }


        // Level 2 — inside a mega menu
        const megaMenu = this.closest('.nav-popup-mega-menu');
        if (megaMenu) {
            megaMenu.classList.remove('nav-popup-mega-menu-active');
            closeAllInnerInnerMenus();
            unlockPanel(popupInner);
        }
    });
});


// ====================== KEYBOARD ======================
document.addEventListener('keydown', function(e) {
    if (e.key === "Escape") {
        // Close level 3 first if open
        const activeInnerInner = document.querySelector('.inner-inner-menu-active');
        if (activeInnerInner) {
            const parentMegaMenu = activeInnerInner.closest('.nav-popup-mega-menu');
            activeInnerInner.classList.remove('inner-inner-menu-active');
            unlockPanel(parentMegaMenu);   // restore mega menu on Escape
            return;
        }

        // Then close the whole popup
        if (popupMain.classList.contains('nav-popup-active')) {
            toggleNavPopup();
        }
    }
});
      // RESPONSIVE MEGA MENU  

      // SEARCH POPUP
      // Open search popup
      document.querySelectorAll(".search-open").forEach((open) => {
        open.addEventListener("click", function () {
          console.log("click");

          document
            .querySelector(".search-popup-main")
            .classList.add("search-active");
          document.body.style.overflow = "hidden";
        });
      });

      // Close search popup
      document
        .querySelector(".close-search-popup")
        .addEventListener("click", function () {
          document
            .querySelector(".search-popup-main")
            .classList.remove("search-active");
          document.body.style.overflow = "";
        });
      // SEARCH POPUP
// ====================== COMPLETE DYNAMIC SEARCH ======================
(function() {
  // DOM Elements
  const searchInput = document.querySelector('.search-popup-input input');
  const popularList = document.getElementById('popular-searches-list');
  const collectionsList = document.getElementById('collections-list');
  const latestNewsList = document.getElementById('latest-news-list');
  const recommendedList = document.getElementById('recommended-products-list');
  const clearIcon = document.querySelector('.search-clear-icon');
  
  let debounceTimer;
  let currentQuery = '';
  
  // Loader HTML
  const loaderHTML = `
    <div class="search-loader">
      <div class="spinner"></div>
      <span>Searching...</span>
    </div>
  `;
  
  // Show loader function
  function showLoader(container) {
    if (container) container.innerHTML = loaderHTML;
  }
  
  // ====================== DEFAULT CONTENT FROM CUSTOMIZER ======================
  function loadDefaultPopular() {
    if (!popularList) return;
    const popularSearches = window.searchDefaults?.popularSearches || ['Happy Sport', 'Happy Diamonds', 'Ice Cube'];
    let html = '';
    popularSearches.forEach(term => {
      if (term.trim()) {
        html += `<li><a href="#" class="popular-search-term" data-term="${escapeHtml(term.trim())}">${escapeHtml(term.trim())}</a></li>`;
      }
    });
    popularList.innerHTML = html;
    
    // Add click handlers for popular terms
    document.querySelectorAll('.popular-search-term').forEach(link => {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        const term = this.getAttribute('data-term');
        if (searchInput && term) {
          searchInput.value = term;
          searchInput.dispatchEvent(new Event('input'));
          toggleClearIcon();
        }
      });
    });
  }
  
  function loadDefaultCollections() {
    if (!collectionsList) return;
    const collections = window.searchDefaults?.defaultCollections || [];
    if (collections.length === 0) {
      collectionsList.innerHTML = '<div class="no-data">No collections available</div>';
      return;
    }
    let html = '';
    collections.forEach(collection => {
      html += `<div><a href="${collection.url}">${escapeHtml(collection.title)}</a></div>`;
    });
    collectionsList.innerHTML = html;
  }
  
  function loadDefaultBlogs() {
    if (!latestNewsList) return;
    
    const articles = window.searchDefaults?.defaultArticles || [];
    
    if (articles.length === 0) {
      latestNewsList.innerHTML = '<div class="no-data">No news available</div>';
      return;
    }
    
    let html = '';
    articles.forEach(article => {
      html += `
        <div class="news">
          <a href="${article.url}">
            ${article.image ? `<picture><img src="${article.image}" alt="${escapeHtml(article.title)} blog" width="130" height="95"></picture>` : ''}
            <div class="news-cont">
              <p>${escapeHtml(article.title.substring(0, 60))}</p>
            </div>
          </a>
        </div>
      `;
    });
    
    latestNewsList.innerHTML = html;
  }
  
  function loadDefaultProducts() {
    if (!recommendedList) return;
    const products = window.searchDefaults?.defaultProducts || [];
    if (products.length === 0) {
      recommendedList.innerHTML = '<div class="no-data">No products available</div>';
      return;
    }
    let html = '';
    products.slice(0, 4).forEach(product => {
      html += `
        <div class="recommended-card">
          <a href="${product.url}">
            <picture>
              <img class="img-vid-cover" src="${product.image}" alt="${escapeHtml(product.title)}" loading="lazy">
            </picture>
            <span class="rec-card-title">${escapeHtml(product.title.substring(0, 40))}</span>
            <span>${product.price}</span>
          </a>
        </div>
      `;
    });
    recommendedList.innerHTML = html;
  }
  
  // ====================== DYNAMIC SEARCH FUNCTIONS ======================
  async function fetchDynamicCollections(query) {
    if (!query) return null;
    try {
      const response = await fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=collection&resources[limit]=3`);
      const data = await response.json();
      return data.resources?.results?.collections || null;
    } catch (error) {
      return null;
    }
  }
  
  async function fetchDynamicBlogs(query) {
    if (!query) return null;
    try {
      const response = await fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=article&resources[limit]=3`);
      const data = await response.json();
      return data.resources?.results?.articles || null;
    } catch (error) {
      return null;
    }
  }
  
  async function fetchDynamicProducts(query) {
    if (!query) return null;
    try {
      const response = await fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6`);
      const data = await response.json();
      return data.resources?.results?.products || null;
    } catch (error) {
      return null;
    }
  }
  
  // ====================== SMART POPULAR SEARCH WITH MATCHING ======================
  async function updatePopularSearchesWithMatch(query) {
    if (!popularList) return;
    
    const defaultPopular = window.searchDefaults?.popularSearches || ['Happy Sport', 'Happy Diamonds', 'Ice Cube'];
    
    if (!query || query.length < 2) {
      loadDefaultPopular();
      return;
    }
    
    try {
      const response = await fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product,collection&resources[limit]=5`);
      const data = await response.json();
      
      const products = data.resources?.results?.products || [];
      const collections = data.resources?.results?.collections || [];
      
      const matchingTerms = [];
      
      products.forEach(product => {
        if (product.title && product.title.toLowerCase().includes(query.toLowerCase())) {
          matchingTerms.push(product.title);
        }
      });
      
      collections.forEach(collection => {
        if (collection.title && collection.title.toLowerCase().includes(query.toLowerCase())) {
          matchingTerms.push(collection.title);
        }
      });
      
      defaultPopular.forEach(term => {
        if (term.toLowerCase().includes(query.toLowerCase())) {
          matchingTerms.push(term);
        }
      });
      
      const uniqueTerms = [...new Set(matchingTerms)];
      
      if (uniqueTerms.length > 0) {
        let html = '';
        uniqueTerms.slice(0, 5).forEach(term => {
          const highlightedTerm = highlightSearchTerm(term, query);
          html += `<li><a href="#" class="popular-search-term" data-term="${escapeHtml(term)}">${highlightedTerm}</a></li>`;
        });
        popularList.innerHTML = html;
        
        document.querySelectorAll('.popular-search-term').forEach(link => {
          link.addEventListener('click', function(e) {
            e.preventDefault();
            const term = this.getAttribute('data-term');
            if (searchInput && term) {
              searchInput.value = term;
              searchInput.dispatchEvent(new Event('input'));
              toggleClearIcon();
            }
          });
        });
      } else {
        popularList.innerHTML = `<li class="no-popular-match">We could not find any results for "${escapeHtml(query)}". Please try another search term.</li>`;
      }
      
    } catch (error) {
      console.error('Popular search fetch error:', error);
      const matchedTerms = defaultPopular.filter(term => 
        term.toLowerCase().includes(query.toLowerCase())
      );
      
      if (matchedTerms.length > 0) {
        let html = '';
        matchedTerms.forEach(term => {
          const highlightedTerm = highlightSearchTerm(term, query);
          html += `<li><a href="#" class="popular-search-term" data-term="${escapeHtml(term)}">${highlightedTerm}</a></li>`;
        });
        popularList.innerHTML = html;
      } else {
        popularList.innerHTML = `<li class="no-popular-match">We could not find any results for "${escapeHtml(query)}". Please try another search term.</li>`;
      }
    }
  }
  
  // ====================== HIGHLIGHT FUNCTIONS ======================
  function highlightSearchTerm(term, query) {
    if (!query) return escapeHtml(term);
    const regex = new RegExp(`(${escapeRegex(query)})`, 'gi');
    return escapeHtml(term).replace(regex, '<mark class="popular-highlight">$1</mark>');
  }
  
  function escapeRegex(string) {
    if (!string) return '';
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }
  
  // ====================== CLEAR ICON FUNCTIONALITY ======================
  function toggleClearIcon() {
    if (clearIcon) {
      if (searchInput && searchInput.value.length > 0) {
        clearIcon.style.display = 'flex';
      } else {
        clearIcon.style.display = 'none';
      }
    }
  }
  
  // Clear input on icon click
  if (clearIcon) {
    clearIcon.addEventListener('click', function() {
      if (searchInput) {
        searchInput.value = '';
        searchInput.dispatchEvent(new Event('input'));
        searchInput.focus();
        toggleClearIcon();
      }
    });
  }
  
  // ====================== MAIN PERFORM SEARCH ======================
  async function performSearch(query) {
    if (!query || query.length < 2) {
      loadDefaultPopular();
      loadDefaultCollections();
      loadDefaultBlogs();
      loadDefaultProducts();
      return;
    }
    
    showLoader(collectionsList);
    showLoader(latestNewsList);
    showLoader(recommendedList);
    
    await updatePopularSearchesWithMatch(query);
    
    const [collections, blogs, products] = await Promise.all([
      fetchDynamicCollections(query),
      fetchDynamicBlogs(query),
      fetchDynamicProducts(query)
    ]);
    
    // Collections
    if (collections && collections.length > 0) {
      let html = '';
      collections.slice(0, 3).forEach(collection => {
        html += `<div><a href="${collection.url}">${escapeHtml(collection.title)}</a></div>`;
      });
      collectionsList.innerHTML = html;
    } else {
      loadDefaultCollections();
    }
    
    // Blogs
    if (blogs && blogs.length > 0) {
      let html = '';
      blogs.slice(0, 3).forEach(article => {
        let imageUrl = '';
        if (article.image) {
          imageUrl = typeof article.image === 'string' ? article.image : (article.image.src || '');
        } else if (article.image_url) {
          imageUrl = article.image_url;
        }
        if (imageUrl) {
          imageUrl = imageUrl.replace(/(\.(jpg|jpeg|png|webp))(\?.*)?$/i, '_130x$1');
        }
        html += `
          <div class="news">
            <a href="${article.url}">
              ${imageUrl ? `<picture><img src="${imageUrl}" alt="${escapeHtml(article.title)}" width="130" height="95" ></picture>` : ''}
              <div class="news-cont">
                <p>${escapeHtml(article.title.substring(0, 60))}</p>
              </div>
            </a>
          </div>
        `;
      });
      latestNewsList.innerHTML = html;
    } else {
      loadDefaultBlogs();
    }
    
    // Products
    if (products && products.length > 0) {
      let html = '';
      products.slice(0, 4).forEach(product => {
        const price = product.variants && product.variants[0] ? formatMoney(product.variants[0].price) : '';
        let imageUrl = '';
        
        if (product.featured_image) {
          imageUrl = typeof product.featured_image === 'string' ? product.featured_image : (product.featured_image.url || product.featured_image.src || '');
        } else if (product.image) {
          imageUrl = typeof product.image === 'string' ? product.image : (product.image.src || product.image.url || '');
        } else if (product.images && product.images[0]) {
          imageUrl = typeof product.images[0] === 'string' ? product.images[0] : (product.images[0].src || product.images[0].url || '');
        }
        
        if (imageUrl) {
          imageUrl = imageUrl.replace(/(\.(jpg|jpeg|png|webp))(\?.*)?$/i, '_400x$1');
        }
        
        html += `
          <div class="recommended-card">
            <a href="${product.url}">
              <picture>
                <img class="img-vid-cover" src="${imageUrl}" alt="${escapeHtml(product.title)}" loading="lazy">
              </picture>
              <span class="rec-card-title">${escapeHtml(product.title.substring(0, 40))}</span>
              ${price ? `<span>${price}</span>` : ''}
            </a>
          </div>
        `;
      });
      
      const popupContent = document.querySelector('.search-popup-content');
      document.querySelector('.show-all-btn-container')?.remove();
      
      if (products.length >= 3 && popupContent) {
        popupContent.insertAdjacentHTML('afterend', `
          <div class="show-all-btn-container">
            <button class="show-all-search-btn" data-query="${escapeHtml(query)}">SHOW ALL</button>
          </div>
        `);
      }
      recommendedList.innerHTML = html;
      
      document.querySelectorAll('.show-all-search-btn').forEach(btn => {
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          const searchQuery = this.getAttribute('data-query');
          if (searchQuery) {
            window.location.href = `/search?q=${encodeURIComponent(searchQuery)}&type=product`;
          }
        });
      });
    } else {
      loadDefaultProducts();
    }
  }
  
  // Helper functions
  function formatMoney(price) {
    if (!price) return '';
    const amount = parseFloat(price);
    if (isNaN(amount)) return '';
    return '$' + amount.toFixed(2);
  }
  
  function escapeHtml(str) {
    if (!str) return '';
    return str.replace(/[&<>]/g, function(m) {
      if (m === '&') return '&amp;';
      if (m === '<') return '&lt;';
      if (m === '>') return '&gt;';
      return m;
    });
  }
  
  // ====================== EVENT LISTENERS ======================
  
  // Input event with debouncing
  if (searchInput) {
    searchInput.addEventListener('input', function(e) {
      clearTimeout(debounceTimer);
      currentQuery = e.target.value.trim();
      toggleClearIcon();
      
      debounceTimer = setTimeout(() => {
        performSearch(currentQuery);
      }, 300);
    });
  }
  
  // When search popup opens, reset everything
  const searchOpenButtons = document.querySelectorAll('.search-open');
  searchOpenButtons.forEach(btn => {
    btn.addEventListener('click', function() {
      setTimeout(() => {
        if (searchInput) {
          searchInput.value = '';
          currentQuery = '';
          performSearch('');
          searchInput.focus();
          toggleClearIcon();
        }
      }, 100);
    });
  });
  
  // Initialize default content on page load
  if (document.querySelector('.search-popup-main')) {
    performSearch('');
  }
})();